/**
 * FAQ section — one accordion open at a time, and paginate long lists.
 */
(function () {
  function closeSiblingAccordions(item, items) {
    items.forEach((other) => {
      if (other === item || !other.open) return;
      other.open = false;
    });
  }

  function parsePageSize(value, fallback) {
    var size = parseInt(value, 10);
    return isNaN(size) || size < 1 ? fallback : size;
  }

  function currentPageSize(box) {
    var desktop = parsePageSize(box.getAttribute('data-faq-page-size'), 10);
    var mobile = parsePageSize(box.getAttribute('data-faq-page-size-mobile'), 5);
    return window.matchMedia('(max-width: 749px)').matches ? mobile : desktop;
  }

  function initFaqPager(box, items) {
    if (box.getAttribute('data-faq-paged') === '1') return;

    var desktopSize = parsePageSize(box.getAttribute('data-faq-page-size'), 10);
    var mobileSize = parsePageSize(box.getAttribute('data-faq-page-size-mobile'), 5);
    if (items.length <= Math.min(desktopSize, mobileSize)) return;

    box.setAttribute('data-faq-paged', '1');
    var page = 0;
    var perPage = currentPageSize(box);
    var pages = Math.ceil(items.length / perPage);
    var nav = document.createElement('div');
    nav.className = 'faq-pager';
    nav.innerHTML =
      '<div class="faq-pager__dots" role="tablist" aria-label="FAQ pages"></div>' +
      '<p class="faq-pager__status"></p>' +
      '<div class="faq-pager__actions">' +
      '<button type="button" class="faq-pager__prev">Previous questions</button>' +
      '<button type="button" class="faq-pager__next">Read more questions</button>' +
      '</div>';
    box.appendChild(nav);

    var dotsWrap = nav.querySelector('.faq-pager__dots');
    var status = nav.querySelector('.faq-pager__status');
    var prev = nav.querySelector('.faq-pager__prev');
    var next = nav.querySelector('.faq-pager__next');
    var dots = [];

    function buildDots() {
      dotsWrap.innerHTML = '';
      dots = [];
      for (var d = 0; d < pages; d += 1) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'faq-pager__dot';
        dot.setAttribute('aria-label', 'Show questions page ' + (d + 1));
        (function (index) {
          dot.addEventListener('click', function () {
            page = index;
            showPage();
          });
        })(d);
        dotsWrap.appendChild(dot);
        dots.push(dot);
      }
    }

    function showPage() {
      var start = page * perPage;
      var end = Math.min(start + perPage, items.length);
      var needsPager = items.length > perPage;
      items.forEach(function (el, i) {
        var on = !needsPager || (i >= start && i < end);
        el.classList.toggle('is-faq-page-hidden', !on);
        if (!on) el.open = false;
      });
      nav.hidden = !needsPager;
      if (!needsPager) return;
      status.textContent = 'Showing ' + (start + 1) + ' to ' + end + ' of ' + items.length + ' questions';
      prev.hidden = page === 0;
      next.hidden = page >= pages - 1;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === page);
        dot.setAttribute('aria-current', i === page ? 'true' : 'false');
      });
    }

    function applyPageSize() {
      var firstVisible = items.findIndex(function (el) {
        return !el.classList.contains('is-faq-page-hidden');
      });
      if (firstVisible < 0) firstVisible = 0;
      perPage = currentPageSize(box);
      pages = Math.ceil(items.length / perPage) || 1;
      page = Math.min(Math.floor(firstVisible / perPage), pages - 1);
      buildDots();
      showPage();
    }

    prev.addEventListener('click', function () {
      if (page === 0) return;
      page -= 1;
      showPage();
    });
    next.addEventListener('click', function () {
      if (page >= pages - 1) return;
      page += 1;
      showPage();
    });

    window.addEventListener('resize', function () {
      var nextSize = currentPageSize(box);
      if (nextSize === perPage) return;
      applyPageSize();
    });

    applyPageSize();
  }

  function initFaqAccordionBox(box) {
    const items = Array.from(box.querySelectorAll('details.faq-accordion'));
    if (items.length < 2) return;

    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (item.open) closeSiblingAccordions(item, items);
      });
    });

    initFaqPager(box, items);
  }

  function initFaqAccordions(root = document) {
    root.querySelectorAll('.faq-accordion-box').forEach(initFaqAccordionBox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initFaqAccordions());
  } else {
    initFaqAccordions();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initFaqAccordions(event.target);
  });
})();
